import { DestroyRef, Directive, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Directive({
	selector: '[btActiveRoute]',
	standalone: true
})
export class ActiveRouteDirective implements OnInit {
	readonly #router = inject(Router);
	readonly #el = inject(ElementRef<HTMLElement>);
	readonly #renderer = inject(Renderer2);
	readonly #destroyRef = inject(DestroyRef);

	#routes: string[] = [];

	@Input('btActiveRoute') set btActiveRoute(routes: string | string[]) {
		this.#routes = Array.isArray(routes) ? routes : [routes];
		this.updateActiveState();
	}

	ngOnInit(): void {
		this.#router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.pipe(takeUntilDestroyed(this.#destroyRef))
			.subscribe(() => this.updateActiveState());

		this.updateActiveState();
	}

	private updateActiveState(): void {
		const isActive = this.#routes.length > 0 && this.#routes.some((route) => !!route && this.#router.url.includes(route));

		if (isActive) {
			this.#renderer.setStyle(this.#el.nativeElement, 'color', 'white');
			this.#renderer.setStyle(this.#el.nativeElement, 'background-color', '#0d47a1');
		} else {
			this.#renderer.removeStyle(this.#el.nativeElement, 'color');
			this.#renderer.removeStyle(this.#el.nativeElement, 'background-color');
		}
	}
}
